<template>
    <div class="row">
        <div class="col-md-6 col-12 mx-auto">

            <h1>{{ $gettext('Permissions') }}</h1>

            <div id="table-wrapper">
                <data-table
                    :columns="columns"
                    :per-page="['10', '25', '50', '100']"
                    :url="url"
                    :filters="filters"
                    ref="permissionsTable"
                >
                    <div slot="filters" slot-scope="{ tableData, perPage }">
                        <div class="row mb-2">
                            <div class="col-md-4">
                                <select class="form-control w-auto me-md-2 me-0 form-input-height" v-model="filters.length">
                                    <option :key="page" v-for="page in perPage">{{ page }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <tbody slot="body" slot-scope="{ data }">
                    <tr
                        :key="item.id"
                        v-for="item in data"
                    >
                        <td :key="column.name" v-for="column in columns"
                            @click="column.name !=='Edit' ? showRowNumber(item.id, item.type) : ''">
                            <data-table-cell
                                :value="item"
                                :name="column.name"
                                :meta="column.meta"
                                :comp="column.component"
                                :classes="column.classes"
                            >
                            </data-table-cell>
                        </td>
                    </tr>
                    </tbody>
                </data-table>
            </div>

            <modal
                :modaltitle="$gettext('Delete Role')"
                :modaltext="$gettext('Do you want to delete this role?')"
                :buttontext="$gettext('Delete')"
            ></modal>
        </div>
    </div>
</template>

<script>
import ActionTableButtons from "./ActionTableButtons.vue";
import { DataTable } from "laravel-vue-datatable";

export default {
    name: "permissions-table",

    props: ["base_url", "current_url"],

    components: {
        ActionTableButtons,
        DataTable,
    },

    data() {
        return {
            url: "",
            filters: {
                length: 10
            },
            rowId: "",
            selectOptions: [],
            columns: [
                {
                    label: this.$gettext("Name"),
                    name: "name",
                    orderable: true,
                },
                {
                    label: this.$gettext("Actions"),
                    name: "Edit",
                    orderable: false,
                    classes: {
                        btn: true,
                        "btn-primary": true,
                        "btn-sm": true,
                    },
                    component: ActionTableButtons,
                    meta: {
                        0: this.base_url + "/admin/permissions",
                    },
                },
            ],
        };
    },

    mounted() {
        this.url = this.base_url + "/admin/permissions-datatable";

        let self = this;

        this.$root.$on("get-datatable-row-id", function (id) {
            this.rowId = id;
        });

        this.$root.$on("modal-confirmed", function () {
            self.deleteRow(this.rowId);
        });
    },

    methods: {
        showRowNumber(id, type) {
            // window.location = "/admin/permissions/" + id;
        },

        deleteRow(id) {
            let url = "/admin/permissions/delete/" + id;

            axios.post(url).then(() => {
                this.$refs.permissionsTable.getData();
            });
        },
    },
};
</script>
